import { $ } from './../helpers/query'
import Swiper from './../imports/import-swiper';

export default () => {
  $('.sustainability').each((section) => {

    const carouselCont = section.querySelector('.sustainability__features-wrapper:not(.do-not-carousel-it)');
    const carouselWrap = carouselCont.querySelector('.sustainability__features');
    const carouselSlides = $('.sustainability-feature', section);

    let carousel;
    toggleCarousel()
    window.addEventListener('resize', toggleCarousel)

    function toggleCarousel() {
      if (document.documentElement.clientWidth < 640 && !carousel) {
        carouselCont.classList.add('swiper-container');
        carouselWrap.classList.add('swiper-wrapper');
        carouselSlides.addClass('swiper-slide')

        carousel = new Swiper(carouselCont, {
          slidesPerView: 1.7,
          spaceBetween: 30,
          pagination: {
            el: ".sustainability__slider-pagination",
            type: "bullets",
            clickable: true,
            renderBullet: function (index, className) {
              return `<button class="sustainability__slider-pagination-bullet ${className}"></button>`;
            },
          }
        })
      } else if (document.documentElement.clientWidth >= 640 && carousel) {
        carousel.destroy()
        carousel = null;
        carouselCont.classList.remove('swiper-container');
        carouselWrap.classList.remove('swiper-wrapper');
        carouselSlides.removeClass('swiper-slide')
      }
    }
  })
}
